var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ModalComponent',{attrs:{"name":'descuento-plazo-' + _vm.plazo_id,"title":"Descuento plazo"},on:{"close":_vm.close}},[_c('DescuentoComponent',{attrs:{"importe":_vm.importe},on:{"descontado":_vm.descontarPlazo,"close":function($event){return _vm.close()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }